import { render, staticRenderFns } from "./TooltipTextFearOvertime.vue?vue&type=template&id=8e9cfb2a"
import script from "./TooltipTextFearOvertime.vue?vue&type=script&lang=js"
export * from "./TooltipTextFearOvertime.vue?vue&type=script&lang=js"
import style0 from "./TooltipTextFearOvertime.vue?vue&type=style&index=0&id=8e9cfb2a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports